<template>
  <div>
    <v-data-table :headers="headers" v-model:search="search" 
    :items="client_users" :items-per-page-options="[
      { value: 5, title: '5' },
      { value: 10, title: '10' },
      { value: 15, title: '15' },
      { value: 20, title: '20' },
    ]" item-value="client_id" :sort-by="[{ key: 'client_id', order: 'desc' }]" class="elevation-1">
      <template v-slot:item.is_active="{ item }">
        <v-switch v-model="item.is_active" @click="updateAccountStatus(item.user_id)" color="success" small inset/>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>User EndPoints</v-toolbar-title>
            <v-btn class="search-btn" 
              icon  variant="text" 
              v-if="!showsearch" 
              @click="showsearch = true">
              <v-icon class="mx-3">mdi-magnify</v-icon>
            </v-btn>

      <!-- Search Field with Close Icon -->
          <v-text-field
            v-if="showsearch"
            v-model="search"
            label="Search Users"
            append-inner-icon="mdi-close"
            @click:append-inner="clearSearch"
            variant="outlined"
            hide-details
            class="mx-4"
            style="max-width: 300px"
          />
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-tooltip location="bottom" text="Add a new user account to your organization">
            <template v-slot:activator="{ props }">
              <v-btn v-bind="props" color="primary" dark class="mb-2" @click="openUserForm" v-if="isAdmin">
                Create New User
              </v-btn>
            </template>
          </v-tooltip>
          <v-tooltip location="bottom" :text="groupsButtonTooltip">
            <template v-slot:activator="{ props }">
              <v-btn v-bind="props" color="primary" dark class="mb-2 ml-2" @click="openGroupsDialog">
                <v-icon left>mdi-account-group</v-icon>
                {{ groupsButtonLabel }}
              </v-btn>
            </template>
          </v-tooltip>
          <v-tooltip location="bottom" text="Generate Plivo credentials for users who don't have phone/text enabled yet">
            <template v-slot:activator="{ props }">
              <v-btn v-bind="props" color="primary" dark class="mb-2 ml-2" @click="enable" v-if="isAdmin">
                Enable Phone/Text
              </v-btn>
            </template>
          </v-tooltip>
          <v-dialog v-model="ivrDialog" max-width="500px">
            <v-card>
              <v-card-title class="text-h5"> {{ editedItem.username + " IVR Digits" }} </v-card-title>
              <v-card-text style="margin-top: 10px">
                <v-data-table-virtual v-model="ivr_selected" :headers="[{ title: 'IVR Number', key: 'ivr_des' }]"
                  :items="ivr_list" item-value="ivr_des" show-select class="elevation-1">
                </v-data-table-virtual>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="closeEdit">Close</v-btn>
                <v-btn color="green" text @click="saveIVR">Save</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- User Groups Management Modal -->
          <UserGroupsModal v-model="groupsDialog" :readOnly="!isAdmin" @groupsUpdated="onGroupsUpdated" />
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip location="bottom" text="Edit">
          <template v-slot:activator="{ props }">
            <v-icon v-bind="props" size="small" class="mr-2" @click="openUserEditForm(item)">
              mdi-pencil
            </v-icon>
          </template>
        </v-tooltip>
        <v-tooltip location="bottom" text="Edit IVR Tree">
          <template v-slot:activator="{ props }">
            <v-icon v-bind="props" class="mr-2" size="small" v-if="hasPlivoCreds(item) && ivr_list.length > 0"
              @click="editIVR(item)">
              mdi-account
            </v-icon>
          </template>
        </v-tooltip>
      </template>
      <template v-slot:item.role="{ item }">
        <v-select :items="['Admin', 'Member', 'Claims Specialist']" v-model="item.role" @update:model-value="() => saveRole(item)"
          variant='underlined' dense hide-details></v-select>
      </template>
      <template v-slot:item.user_group_name="{ item }">
        <div class="d-flex flex-column pl-4" style="gap: 2px; line-height: 1.4;">
          <template v-if="item.user_group_name">
            <template 
              v-for="(group, idx) in item.user_group_name.split(',').map(g => g.trim()).filter(g => g !== 'ALL USERS')"
              :key="idx"
            >
              <div class="text-caption text-primary font-weight-medium">
                {{ group }}
              </div>
            </template>
          </template>
        </div>
      </template>
      <template v-slot:item.plivo_creds="{ item }">
        {{ plivoCreds(item) }}
      </template>
    </v-data-table>
    <UserForm  v-if="userForm" v-model="userForm" :dialog="userForm" :isEdit="editUser" :selectedUser="selectedUser" @closeDialog="userForm = false"/>
  </div>
</template>

<script>
import AdminService from "@/services/adminService";
import router from "@/router";
import MiscService from "@/services/miscService";
import UserForm from "./UserForm.vue";
import UserGroupsModal from "./UserGroupsModal.vue";
import { mapGetters } from "vuex";
import EventBus from "@/eventBus";
export default {
  data: () => ({
    router,
    search: "",
    showsearch:false,
    client_id: 0,
    ivr_selected: [],
    headers: [
      {
        title: 'User Name',
        align: 'start',
        sortable: true,
        key: 'username',
      },
      { title: 'First Name', key: 'first_name' },
      { title: 'Last Name', key: 'last_name' },
      { title: 'Role', key: 'role' },
      { title: 'User Group(s)', key: 'user_group_name' },
      { title: 'Phone/Text Enabled', key: 'plivo_creds', align: "center" },
      { title: 'Active Status', key: 'is_active' },
      { title: 'Actions', key: 'actions', sortable: false }
    ],
    client_users: [],
    ivr_list: [],
    ivrDialog: false,
    editedIndex: -1,
    editedItem: {
      user_id: 0,
      username: '',
      role: '',
    },
    defaultItem: {
      user_id: 0,
      username: '',
      role: '',
    },
    userForm : false,
    editUser : false,
    selectedUser : null,
    groupsDialog: false,
  }),
  components: { UserForm, UserGroupsModal },
  computed: {
    ...mapGetters(['isAdmin']),
    groupsButtonLabel() {
      return this.isAdmin ? 'View/Manage Groups' : 'View Groups';
    },
    groupsButtonTooltip() {
      return this.isAdmin 
        ? 'Create and manage user groups for organizing team members'
        : 'View available user groups in your organization';
    }
  },
  methods: {
    async initialize() {
      let client_list = await AdminService.getClientEndpoints();
      this.client_users = client_list.data;

      let ivr = await AdminService.getClientIVR();
      this.ivr_list = ivr.data;
    },
    hasPlivoCreds(item) {
      // console.log(item);
      return item.plivo_user;
    },
    plivoCreds(item) {
      return (this.hasPlivoCreds(item) ? "Yes" : "No");
    },
    async editIVR(item) {
      let ivr_digits = await AdminService.getIVRDesignation(item.user_id);
      console.log(ivr_digits);
      this.ivr_selected = ivr_digits.data;

      this.editedIndex = this.client_users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.ivrDialog = true;
    },
    closeEdit() {
      this.ivrDialog = false;

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      });
    },
    async saveIVR() {
      let selectedObjs = []
      this.selected.forEach((digit) => selectedObjs.push({ ivr_des: digit }));
      await AdminService.updateIVR(selectedObjs, this.editedItem.user_id);
      this.closeEdit();
    },
    async saveRole(item) {
      console.log("saverole", item.user_id, item.role);
      if (item.role === 'Admin') {
        alert('Admin alerted!');
      }
      try {
        await AdminService.updateUserRole(item.user_id, item.role);
      } catch (error) {
        console.log(error);
      }

    },
    clearSearch() {
        this.search = "";
        this.showsearch = false;
        },
    async enable() {
      try {
        await AdminService.newEndpoints();
        // Refresh the user list to show updated Plivo credentials
        await this.initialize();
      } catch (error) {
        console.log(error);
      }
    },
    // Update user activation status
    async updateAccountStatus(user_id) {
      try {
        let res = await MiscService.updateActiveStatus(user_id);
        console.log(res);
      } catch (error) {
        console.error(error)
      }
    },
    openUserForm(){
      this.userForm = true;
      this.editUser = false;
      this.selectedUser = null;
    },
    openUserEditForm(item){
      this.userForm = true;
      this.editUser = true;
      this.selectedUser = item;
    },
    openGroupsDialog() {
      this.groupsDialog = true;
    },
    onGroupsUpdated() {
      // Optional: refresh user list if needed after groups are updated
      this.initialize();
    }
  },

  created() {
    this.initialize();
    console.log(this.client_users)
  },
  mounted() {
    EventBus.$on('refreshClientEndpoints', () => {
      this.initialize();
    });
  },
  beforeUnmount() {
    EventBus.$off('refreshClientEndpoints');
  }
}
</script>
<style scoped>
.search-btn {
  margin-left: 12px;
  color: #555;
  transition: 0.2s ease-in-out;
}

.search-btn:hover {
  color: #1976d2;
  transform: scale(1.1);
}
</style>